"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "buildXmlDom", {
  enumerable: true,
  get: function get() {
    return _dom.buildXmlDom;
  }
});
Object.defineProperty(exports, "createElement", {
  enumerable: true,
  get: function get() {
    return _element.createElement;
  }
});
Object.defineProperty(exports, "makeElementCreator", {
  enumerable: true,
  get: function get() {
    return _element.makeElementCreator;
  }
});
Object.defineProperty(exports, "makeEmptyDom", {
  enumerable: true,
  get: function get() {
    return _dom.makeEmptyDom;
  }
});
Object.defineProperty(exports, "makeProcessingInstruction", {
  enumerable: true,
  get: function get() {
    return _processingInstruction.makeProcessingInstruction;
  }
});
Object.defineProperty(exports, "parseXmlString", {
  enumerable: true,
  get: function get() {
    return _dom.parseXmlString;
  }
});

var _element = require("./element.creators");

var _dom = require("./dom.creators");

var _processingInstruction = require("./processingInstruction.creators");